import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { CustomError } from '@core/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { pick } from 'es-toolkit';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { AuthQueryOptions } from '@/api';
import { HospitalCard } from '@/components/molecule/HospitalCard';
import { ROUTES } from '@/constants';
import { EmptyScrapList } from './EmptyScrapList';
const DAY_OF_WEEK_MAP = new Map([['mon', '월요일'], ['tue', '화요일'], ['wed', '수요일'], ['thu', '목요일'], ['fri', '금요일'], ['sat', '토요일'], ['sun', '일요일'], ['hol', '공휴일']]);
const EmergencyScrapListContent = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/member/wishlist/emergency-room"](),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: emergencyRoomScrap
  } = useSuspenseQuery(t0);
  if (!emergencyRoomScrap?.totalCount) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyScrapList />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== emergencyRoomScrap.totalCount) {
    t1 = <p className="px-20 py-10 font-500 text-Gray-black typo-body4">총 {emergencyRoomScrap.totalCount}개</p>;
    $[2] = emergencyRoomScrap.totalCount;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== emergencyRoomScrap.contents) {
    t2 = emergencyRoomScrap?.contents?.map(_temp3);
    $[4] = emergencyRoomScrap.contents;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <ul className="flex flex-col gap-16 px-20">{t2}</ul>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <article className="flex flex-col">{t1}{t3}</article>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const EmergencyScrapList = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="my-10 ml-20 h-21 w-45 rounded-xxsmall" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ErrorBoundary fallback={null}><Suspense fallback={<article className="flex flex-col">{t0}<ul className="flex flex-col gap-16 px-20">{Array.from({
            length: 5
          }).map(_temp4)}</ul></article>}><EmergencyScrapListContent /></Suspense></ErrorBoundary>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context;
}
function _temp2(t0) {
  const [key_0, value_0] = t0;
  const day_1 = DAY_OF_WEEK_MAP.get(key_0);
  return `${day_1} ${value_0.startTime} ~ ${value_0.endTime}`;
}
function _temp3(t0) {
  const {
    emergencyRoomId: emergency_room_id,
    ...emergencyRoom
  } = t0;
  const dayObj = pick(emergencyRoom, ["mon", "tue", "wed", "thu", "fri", "sat", "sun", "hol"]);
  let todayText = "";
  const restDays = [];
  const dayTextList = Object.entries(dayObj).filter(t1 => {
    const [key, value] = t1;
    if (!value) {
      const day = DAY_OF_WEEK_MAP.get(key);
      if (!day) {
        throw new CustomError({
          return_message: "\uC798\uBABB\uB41C \uC694\uC77C \uB370\uC774\uD130\uAC00 \uC874\uC7AC\uD569\uB2C8\uB2E4."
        });
      }
      restDays.push(day);
      return false;
    }
    if (value.today) {
      const day_0 = DAY_OF_WEEK_MAP.get(key);
      todayText = `${day_0} ${value.startTime} ~ ${value.endTime}`;
      return false;
    }
    return true;
  }).map(_temp2);
  if (restDays.length) {
    dayTextList.push(`${restDays.join(",")} 휴진`);
  }
  return <li key={emergency_room_id}><HospitalCard isUseBookmark={true} address={emergencyRoom.dutyAddr} className="border-b border-Gray-200" dayTextList={dayTextList} emergencyTel={emergencyRoom.dutyTel3} href={ROUTES.RECOMMEND_POLICY_SITUATION_EMERGENCY_DETAIL.withSearchParams({
      dynamicPath: {
        id: emergency_room_id
      },
      searchParams: {
        symptomCode: undefined
      }
    })} id={emergency_room_id} isBookmarked={emergencyRoom.wishlistYN} tel={emergencyRoom.dutyTel1} title={emergencyRoom.dutyName} todayText={todayText} type={emergencyRoom.dutyDivNam} /></li>;
}
function _temp4(_, index) {
  return <li key={index} className="border-b border-Gray-200 pb-8 pt-16 last:border-none"><Skeleton className="mb-8 h-24 w-100" /><Skeleton className="mb-4 h-21 w-250" /><Skeleton className="mb-4 h-21 w-120" /><Skeleton className="mb-8 h-21 w-280" /></li>;
}